var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomNavigation = void 0;
var React = __importStar(require("react"));
var BottomNavigation_1 = __importDefault(require("@material-ui/core/BottomNavigation"));
/**
 * For more advanced usages, check [Material UI Bottom Navigation docs](https://material-ui.com/components/bottom-navigation/)
 *
 * ## Importing
 *
 * ```
 * import { BottomNavigation } from '@naturacosmeticos/natds-web';
 *```
 */
exports.BottomNavigation = React.forwardRef(function (props, ref) { return (React.createElement(BottomNavigation_1.default, __assign({}, props, { ref: ref }))); });
exports.BottomNavigation.displayName = 'BottomNavigation';
exports.default = exports.BottomNavigation;
//# sourceMappingURL=BottomNavigation.js.map